import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled } from "@mui/material";
import { useState } from "react";
import type { Event } from "../../graphql/types";
import { EventLogRow } from "../EventLogRow";

const EventTable = styled(Table)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const EventLogTable = ({ events }: { events: Event[] }) => {
  const [rowSelected, setRowSelected] = useState<string | null>(null);

  const handleRowSelected = (click: React.MouseEvent<HTMLAnchorElement, MouseEvent>, id: string) => {
    if (id && id === rowSelected) {
      setRowSelected(null);
    } else {
      setRowSelected(id);
    }
  };

  const rows = events.map((e, idx) => {
    return <EventLogRow key={idx} event={e} onClick={handleRowSelected} selected={rowSelected === e.id} />;
  });

  return (
    <TableContainer component={Paper}>
      <EventTable id={"event-log-table"} className="flows-table table-striped" data-cy="event-log-table" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell align="center"></TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell>Created</TableCell>
            <TableCell>Message</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{rows}</TableBody>
      </EventTable>
    </TableContainer>
  );
};

export { EventLogTable };
